<template>
  <div id="app">
    <div id="summernote"></div>
    <a-config-provider :locale="zhCN">
      <keep-alive>
        <router-view />
      </keep-alive>
    </a-config-provider>
  </div>
</template>
<script setup>
import locale from "ant-design-vue/es/locale/zh_CN";
export default {
  name: "App",
  data() {
    return {
      zhCN: locale
    };
  },
  watch: {
    $route: {
      handler(row) {
        console.log(12223);
        setTimeout(()=>{
          var _hmt = _hmt || [];
          (function() {
            var hm = document.createElement("script");
            hm.src = "https://hm.baidu.com/hm.js?9d39fab91872e998df17a4865babd993";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
          })();

        },1000)

      },
      immediate: true
    }
  },
};
</script>

<!--<style>-->
<!--#app {-->
<!--  font-family: 'Avenir', Helvetica, Arial, sans-serif;-->
<!--  -webkit-font-smoothing: antialiased;-->
<!--  -moz-osx-font-smoothing: grayscale;-->
<!--  text-align: center;-->
<!--  color: #2c3e50;-->
<!--}-->
<!--</style>-->
<style lang="less">
.ant-table-thead > tr > th {
  text-align: center;
}
.ant-table-tbody > tr > td {
  text-align: center;
}


.no-check-star{
  .ant-form-item-label>.ant-form-item-required::before/deep/{
    content: '';
    width: 0px;
    margin-right: 0px;
    display: inline;
  }
}

body {
  overflow: hidden;
}
#app,
.app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

#nprogress .bar {
  background: #0A5BA8 !important;
}

//.ant-btn-primary{
//  background: #09a99f;
//}
//.ant-checkbox-checked .ant-checkbox-inner{
//  background: #f6af1f;
//  border-color: #f6af1f;
//}
</style>



// WEBPACK FOOTER //
// src/App.vue